<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
  <div *ngIf="!dayView" class="title-wrapper" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
    <span class="phase">{{ phase }}</span>
    <document-workout-selector
      class="workout-selector"
      [day]="day"
      [canEdit]="canEdit"
      (workoutSelected)="workoutSelected.emit($event)"
      (standardWorkoutAdded)="standardWorkoutAdded.emit($event)"
      (customWorkoutAdded)="customWorkoutAdded.emit($event)"
      (restrictedWorkoutAdded)="restrictedWorkoutAdded.emit($event)"
      (workoutAddedFromLibrary)="workoutAddedFromLibrary.emit($event)"
    ></document-workout-selector>
    <span class="date">{{ date }}</span>
  </div>
  <div *ngIf="dayView" class="title">{{ title }}</div>
  <button id="edit-workout-btn" *ngIf="canEdit && !isRestricted && !dayView" fxFlex="10" mat-raised-button color="secondary" (click)="switchView()">EDIT</button>
  <button id="complete-workout-btn" *ngIf="canEdit && !isRestricted && !dayView" fxFlex="10" mat-raised-button color="primary" (click)="markDayCompleted()">Complete</button>  
  <span fxFlex></span>
  <button *ngIf="copying" class="mat-button--copy" mat-button color="warning" (click)="cancelCopy()">Cancel</button>
  <button *ngIf="copying" class="mat-button--copy" mat-raised-button color="primary" (click)="pasteDay()">Paste</button>
  <button id="day-menu" mat-icon-button [matMenuTriggerFor]="dayMenu" [disabled]="copying">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #dayMenu>
    <button mat-menu-item (click)="switchView()" *ngIf="!isRestricted">
      <mat-icon>visibility</mat-icon>
      <span>Switch View</span>
    </button>
    <button mat-menu-item (click)="copyDay(true)" *ngIf="canEdit">
      <mat-icon>filter_none</mat-icon>
      <span>Copy</span>
    </button>
    <button mat-menu-item (click)="markDayCompleted()" *ngIf="canEdit && !isRestricted">
      <mat-icon>check</mat-icon>
      <span>Mark Day as Complete</span>
    </button>
    <button mat-menu-item (click)="addWorkoutToLibrary()" *ngIf="!isRestricted">
      <mat-icon>bookmark</mat-icon>
      <span>Add to Library</span>
    </button>
    <button mat-menu-item (click)="cleared.emit(workout)" *ngIf="canEdit">
      <mat-icon>close</mat-icon>
      <span>Clear</span>
    </button>
    <button mat-menu-item (click)="downloaded.emit(workout.id)" *ngIf="!isRestricted" [disabled]="!isOnline || !isSynced">
      <mat-icon>cloud_download</mat-icon>
      <span>Download Workout</span>
    </button>
    <button mat-menu-item (click)="programmingChartOpened.emit()" *ngIf="!isRestricted">
      <mat-icon>table_chart</mat-icon>
      <span>Programming Chart</span>
    </button>
  </mat-menu>
</div>
